export const getHeader = ({ deductions, contributionType }) => {
  console.log("deductionsssdasd", deductions);
  console.log("contributionType", contributionType);
  const headers = [
    { rowSpan: 2, label: "PAYROLL PERIOD" },
    { rowSpan: 2, label: "PAYROLL TYPE" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
     { rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" },
    { rowSpan: 2, label: "PERA ADA FOR BACK-PAY" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 4, label: "DEDUCTION BEFORE TAX" },
    { rowSpan: 2, label: "EARNED BASIC" },
    { rowSpan: 4, label: "EARNED PERA ADA" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductions.length > 0
      ? [
          {
            colSpan: deductions.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const primarySubHeaders = [
    "DEDUCTION DUE TO LEAVES, LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION(PERA/ADA)",
    "OVERPAYMENT(BASIC)",
    "OVERPAYMENT(PERA ADA)",
    "TAX",
    ...contributionType,
    ...deductions,
  ];
  const secondarySubHeaders = [];

  return [headers, primarySubHeaders, secondarySubHeaders];
};
